import React, { useState } from 'react';
import { Web3Provider } from './contexts/Web3Context';
import PresaleWidget from './components/PresaleWidget';
import AdminPanel from './components/AdminPanel';
import './App.css';

function App() {
  const [showAdmin, setShowAdmin] = useState(false);

  return (
    <Web3Provider>
      <div className="App">
        <header className="App-header">
          <h1>{process.env.REACT_APP_TOKEN_NAME || 'PRE'} Token Presale</h1>
          <p>{process.env.REACT_APP_PRESALE_DESCRIPTION || 'Buy RBN tokens with BNB on BNB Smart Chain'}</p>
          <button 
            className="admin-toggle"
            onClick={() => setShowAdmin(!showAdmin)}
            style={{
              background: 'rgba(255, 255, 255, 0.1)',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              color: 'white',
              padding: '8px 16px',
              borderRadius: '20px',
              cursor: 'pointer',
              fontSize: '0.9rem',
              marginTop: '1rem'
            }}
          >
            {showAdmin ? 'Hide Admin' : 'Show Admin'}
          </button>
        </header>
        <main>
          {showAdmin ? <AdminPanel /> : <PresaleWidget />}
        </main>
      </div>
    </Web3Provider>
  );
}

export default App;

